import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 mb-3 rounded bg-white text-dark" }
const _hoisted_2 = { class: "d-flex justify-content-between pb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Campaign info", -1)
const _hoisted_4 = { class: "container row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Advertiser", -1)
const _hoisted_6 = { class: "col-sm-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Name", -1)
const _hoisted_8 = { class: "col-sm-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Purchase mode", -1)
const _hoisted_10 = { class: "col-sm-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Date start", -1)
const _hoisted_12 = { class: "col-sm-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Date first answer", -1)
const _hoisted_14 = { class: "col-sm-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Date end", -1)
const _hoisted_16 = { class: "col-sm-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", { class: "col-sm-2" }, "Date last answer", -1)
const _hoisted_18 = { class: "col-sm-10" }


import { formatDistanceToNowStrict, parseJSON, format } from "date-fns";
import { fr } from 'date-fns/locale';
import { Campaign } from "@/interfaces/Campaign";
import CreativeDeliveryButton from "./CreativeDeliveryButton.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    campaign: null
  },
  setup(__props: any) {

function dateDisplay(str: string): string {
    return format(parseJSON(str), "dd MMM yyyy", { locale: fr });
}

function timestampDisplay(str: string): string {
    if (null === str) {
        return '-';
    }

    const timestamp = parseJSON(str);

    return `${format(timestamp, "dd MMM yyyy HH:mm:ss", { locale: fr })} (${formatDistanceToNowStrict(timestamp, { 
        addSuffix: true,
		roundingMethod: 'floor',
        locale: fr
    })})`;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      _createVNode(CreativeDeliveryButton, {
        "campaign-id": __props.campaign.uuid
      }, null, 8, ["campaign-id"])
    ]),
    _createElementVNode("dl", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("dd", _hoisted_6, _toDisplayString(__props.campaign.advertiser), 1),
      _hoisted_7,
      _createElementVNode("dd", _hoisted_8, _toDisplayString(__props.campaign.name), 1),
      _hoisted_9,
      _createElementVNode("dd", _hoisted_10, _toDisplayString(__props.campaign.purchaseMode.label), 1),
      _hoisted_11,
      _createElementVNode("dd", _hoisted_12, _toDisplayString(dateDisplay(__props.campaign.dateStart)), 1),
      _hoisted_13,
      _createElementVNode("dd", _hoisted_14, _toDisplayString(timestampDisplay(__props.campaign.timestampFirstAnswer)), 1),
      _hoisted_15,
      _createElementVNode("dd", _hoisted_16, _toDisplayString(dateDisplay(__props.campaign.dateEnd)), 1),
      _hoisted_17,
      _createElementVNode("dd", _hoisted_18, _toDisplayString(timestampDisplay(__props.campaign.timestampLastAnswer)), 1)
    ])
  ]))
}
}

})